import { store } from '@/stores'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Register, RouterProvider } from '@tanstack/react-router'
import { Provider as JotaiProvider } from 'jotai'

type AppProps = {
  queryClient: QueryClient
  router: Register['router']
}

function InnerApp({ router }: { router: Register['router'] }) {
  return <RouterProvider router={router} context={{}} />
}

export default function App({ queryClient, router }: AppProps) {
  return (
    <JotaiProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <InnerApp router={router} />
      </QueryClientProvider>
    </JotaiProvider>
  )
}
